export const ongoingEvaluationSupportMessage =
  'If this continues, contact support with the Job ID.';

const messages = {
  timeout:
    `The evaluation timed out before it could finish. Run it again. ${ongoingEvaluationSupportMessage}`,
  access:
    `The evaluation could not access a required service. Try again. ${ongoingEvaluationSupportMessage}`,
  unavailable:
    `A required service is temporarily unavailable. Try again later. ${ongoingEvaluationSupportMessage}`,
  failed:
    `The evaluation could not be completed. Try again. ${ongoingEvaluationSupportMessage}`,
};

export const getOngoingEvaluationError = (
  details: unknown,
  status = 'Failed',
  httpStatus?: number,
): string => {
  let text = '';
  if (typeof details === 'string') {
    text = details;
  } else if (details && typeof details === 'object') {
    const value =
      ('message' in details && details.message) ||
      ('title' in details && details.title);
    if (typeof value === 'string') text = value;
  }

  // Persisted jobs can predate this fix. Only our own messages may reach the UI.
  if (Object.values(messages).includes(text)) return text;
  if (status === 'TimedOut' || /timeout|timed\s*out/i.test(text)) {
    return messages.timeout;
  }
  if (
    httpStatus === 401 ||
    httpStatus === 403 ||
    /\b(unauthorized|forbidden|access denied)\b/i.test(text)
  ) {
    return messages.access;
  }
  if (
    (httpStatus !== undefined && httpStatus >= 500) ||
    /\b(service unavailable|bad gateway|connection refused)\b/i.test(text)
  ) {
    return messages.unavailable;
  }
  return messages.failed;
};
